import { render } from "./StatisticsPage.vue?vue&type=template&id=41103156&scoped=true"
import script from "./StatisticsPage.vue?vue&type=script&lang=js"
export * from "./StatisticsPage.vue?vue&type=script&lang=js"

import "./StatisticsPage.vue?vue&type=style&index=0&id=41103156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41103156"]])

export default __exports__